// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4388":"css/app.6891","5216":"css/admin-app.6891"}[chunkId] + ".css";
};